<div class="background-image-container">

  <div class="background-image">
    <img src="/assets/dspace/images/logo.png" alt="Kumi University Repository">
  </div>

  <div class="container text-center py-5">

    <!-- Logo -->
    <img class="kumi-logo mb-3"
         src="/assets/dspace/images/kumi-banner.jpeg"
         alt="Kumi University Logo">

    <!-- Title -->
    <h1 class="fw-bold">
      Kumi University Repository
    </h1>

    <p class="lead">
      Preserving and sharing Kumi University's research, innovation, scholarly publications,
      theses, dissertations, and academic excellence for global visibility and impact.
    </p>

    <!-- CTA Buttons -->
    <div class="mt-4 button-group">
      <a class="btn btn-kumi" routerLink="/community-list">
        Browse Repository
      </a>

      <a class="btn btn-kumi" href="/submit">
        Submit Research
      </a>
    </div>

    <!-- Repository Statistics -->
    <div class="row mt-5 repository-stats">

      <div class="col-md-3 col-6 mb-3">
        <div class="stat-card">
          <h2>{{ researchPapers }}</h2>
          <p>Research Papers</p>
        </div>
      </div>

      <div class="col-md-3 col-6 mb-3">
        <div class="stat-card">
          <h2>{{ theses }}</h2>
          <p>Theses & Dissertations</p>
        </div>
      </div>

      <div class="col-md-3 col-6 mb-3">
        <div class="stat-card">
          <h2>{{ journals }}</h2>
          <p>Academic Journals</p>
        </div>
      </div>

      <div class="col-md-3 col-6 mb-3">
        <div class="stat-card">
          <h2>{{ communities }}</h2>
          <p>Research Communities</p>
        </div>
      </div>

    </div>

  </div>
</div>
